import { httpClient } from '@/httpClient';
import { isValidDomain } from '@/helpers/urlHelpers';
import config from '@/config'; // eslint-disable-line import/extensions

export default {
  namespaced: true,
  state: {
    isAuth: false,
    currentUser: {
      roles: [{}],
    },
    returnUrl: null,
  },
  getters: {
    hasPermission: (state) => (permission) => state.currentUser.roles?.some((role) => role.name === 'owner')
      || (state.currentUser.permissions ?? []).includes(permission),
  },
  mutations: {
    updateUserProfile(state, profileData) {
      state.currentUser = {
        ...state.currentUser,
        ...profileData,
      };
    },
    login(state) {
      state.isAuth = true;
    },
    logout(state) {
      state.isAuth = false;
      localStorage.removeItem('auth-token');
      delete httpClient.defaults.headers.common.Authorization;
    },
    setCurrentUser(state, data) {
      state.currentUser = data;
    },
    setReturnUrl(state, url) {
      state.returnUrl = url;
    },
  },
  actions: {
    getCurrentUser(store) {
      return httpClient.get('/api/auth').then((resp) => {
        const { data } = resp;
        store.commit('setCurrentUser', data);
        return data;
      });
    },
    saveReturnUrl({ commit }, url) {
      commit('setReturnUrl', url);
    },
    login(store, { email, password }) {
      return httpClient.post('/api/auth/login', { email, password }, {
        withCredentials: true,
      })
        .then((resp) => {
          const { token } = resp.data;
          store.commit('login');
          localStorage.setItem('auth-token', token);
          httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;

          return store.dispatch('getCurrentUser').then(() => {
            const { returnUrl } = store.state;

            if (returnUrl && isValidDomain(returnUrl, config.baseDomain)) {
              window.location.href = returnUrl;
            }
          });
        });
    },
    refreshCookie() {
      return httpClient.post('/api/auth/refresh_cookie', null, {
        withCredentials: true,
      });
    },

    forgotPassword(store, { email }) {
      return httpClient.post('/api/auth/forgot_password', { email }).then(({ data }) => data);
    },
    resetPassword(store, { email, token }) {
      return httpClient.get(`/api/auth/reset_password?email=${email}&token=${token}`).then(({ data }) => data);
    },

    async updateProfile({ commit, state }, profileData) {
      try {
        commit('updateUserProfile', profileData);
      } catch (error) {
        console.error('Error updating profile in store:', error);
        throw error;
      }
    },
  },
};
